import React, { FC, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { setErrors } from '../../../states/containers/common/errorsSlice'
import { getDesktopAppInstallerLink } from '../../../states/apis/desktopApp'
import { DesktopAppInstallerLinkResponse, InstallerInfo } from '../../../states/types/desktopApp'
import { useParams } from 'react-router-dom'
import { LangValue } from '../../../states/types/common'

interface Props {
  style?: any
}

const ClientDownload: FC<Props> = (props) => {
  const {
    style,
  } = props

  const { language } = useParams<{ language: LangValue | string }>()
  const [t, i18n] = useTranslation()
  const dispatch = useDispatch()
  const [clientInstallerInfo, setClientInstallerInfo] = useState<DesktopAppInstallerLinkResponse | undefined>(undefined)
  const [windowsInfo, setWindowsInfo] = useState<InstallerInfo>()
  const [macosInfo, setMacosInfo] = useState<InstallerInfo>()
  /* eslint-disable max-len */
  const ManualLink = "https://qasee.zendesk.com/hc/ja/articles/49548559717657"

  const changeLocale = (installerInfo: DesktopAppInstallerLinkResponse | undefined) => {
    let lang = language
    if (lang === undefined) {
      lang = (navigator.languages && navigator.languages[0]) || navigator.language
      i18n.changeLanguage(lang)
    }
    if (lang === 'ja') {
      setWindowsInfo(installerInfo?.windows)
      setMacosInfo(installerInfo?.macos)
    } else {
      setWindowsInfo(installerInfo?.windows_en)
      setMacosInfo(installerInfo?.macos_en)
    }
  }

  useEffect(() => {
    getDesktopAppInstallerLink()
      .then((result) => {
        changeLocale(result)
        setClientInstallerInfo(result)
      })
      .catch((error) => {
        dispatch(setErrors(error))
      })
  }, [])

  useEffect(() => {
    changeLocale(clientInstallerInfo)
  }, [language])

  return (
    clientInstallerInfo === undefined ? (<></>) : (
      <section
        className="content content-area"
        style={{ ...style }}
      >
        <div className="content-block">
          {/* eslint-disable-next-line react/no-danger */}
          <div style={{ fontSize: "14px", color: "#333333", marginBottom: "14px" }} dangerouslySetInnerHTML={{ __html: t('client.download.description', { url: ManualLink }) }} />
          <div
            className="block-header"
            style={{
              display: "block",
            }}
          >
            <div className="title">
              {t('client.download.for_windows')}
            </div>
          </div>
          <div className="block-detail">
            <a href={windowsInfo?.direct_download_url} className="button" target="_blank" rel="noreferrer">
              {t('client.download.download_button', { version: windowsInfo?.latest_version })}
            </a>
          </div>
        </div>
        <div className="content-block">
          <div
            className="block-header"
            style={{
              display: "block",
            }}
          >
            <div className="title">
              {t('client.download.for_macos')}
            </div>
          </div>
          <div className="block-detail">
            <a href={macosInfo?.direct_download_url} className="button" target="_blank" rel="noreferrer">
              {t('client.download.download_button', { version: macosInfo?.latest_version })}
            </a>
          </div>
        </div>
      </section>
    )
  )
}

ClientDownload.defaultProps = {
  style: undefined,
}

export default ClientDownload
